// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    backendUrl: 'https://dev.security.billcentric.com',
    versionAnteriorUrl: 'https://qa.web.hecbill.hecticus.com/',
    onboarding_id: 1,
    orgId: "1snn5n9w",
    googleClientId: '940790633460-ei7k4mh5tk1cj7nca260rsm7ie6b6vav.apps.googleusercontent.com',
    chatbotEnabled: true,
    createPartnerTabEnabled: true,
    launchToProductionEnabled: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
